import axios from 'axios';
import { toast } from 'sonner';

export const addItem = async (item, quantity = 1) => {
    try {
        const detailsRes = await axios.get(`https://new.myshops.az/api2/app_view.php?id=${item.id}`);
        const total_stock = Number(detailsRes.data.total_stock);

        let addCart = JSON.parse(localStorage.getItem('cart')) || [];
        const itemIndex = addCart.findIndex(cartItem => cartItem.id === item.id);

        let currentQuantity = 0;
        if (itemIndex > -1) {
            currentQuantity = addCart[itemIndex].quantity;
        }

        if (total_stock > 0 && currentQuantity + quantity > total_stock) {
            toast.error("Stokda kifayət qədər məhsul yoxdur.");
            return false;
        }

        if (itemIndex > -1) {
            addCart[itemIndex].quantity += quantity;
        } else {
            addCart.push({ ...item, quantity });
        }

        localStorage.setItem('cart', JSON.stringify(addCart));
        window.dispatchEvent(new Event('cartUpdated'));
        return true;
    } catch (error) {
        console.error("Error adding item to cart", error);
        toast.error("Xəta baş verdi, yenidən cəhd edin.");
        return false;
    }
};